<template>
  <b-modal
      size="xxl"
      v-model="showForm"
      :title="formTitle + ' phản ánh của người dân'"
      @ok="save"
      no-close-on-backdrop
      no-enforce-focus
  >
    <div class="row" v-if="this.callStatus && this.callStatus !== 'ended'">
      <div class="col text-center">
        <button class="btn btn-success btn-sm mr-1" @click="answerCall" v-if="callStatus && callStatus === 'new'">
          <i class="fa fa-phone"></i> Trả lời
        </button>
        <button class="btn btn-danger btn-sm" @click="endCall()" v-if="callStatus && callStatus !== 'ended'">
          <i class="icon16-call-end-white"></i> Kết thúc
        </button>
        <hr/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <form-input
            label="Họ và tên người liên hệ"
            :model="formModel"
            attribute="name"
            :errors="formErrors"
            placeholder="Họ tên người liên hệ"
        ></form-input>

        <form-input
            label="Số điện thoại người liên hệ"
            :model="formModel"
            attribute="number"
            :errors="formErrors"
            placeholder="Số điện thoại người liên hệ"></form-input>

        <form-radio-group :model="formModel" attribute="needer" :errors="formErrors"
                          label="Cần hỗ trợ cho bản thân hay cho người khác" :options="[
            {value: true, text: 'Cho bản thân'},
            {value: false, text: 'Cho người khác'},
          ]"></form-radio-group>

        <form-input
            label="Họ và tên người cần hỗ trợ"
            :model="formModel" :disabled="formModel.needer"
            attribute="needer_name"
            :errors="formErrors"
            placeholder="Họ tên người cần hỗ trợ"
        ></form-input>

        <form-input
            label="Số điện thoại người cần hỗ trợ"
            :model="formModel"
            attribute="needer_number"
            :errors="formErrors" :disabled="formModel.needer"
            placeholder="Số điện thoại người cần hỗ trợ"></form-input>

        <form-radio-group :model="formModel" attribute="gender" :errors="formErrors" label="Giới tính người cần hỗ trợ"
                          :options="genderOptions"></form-radio-group>

        <form-input
            label="Năm sinh người cần hỗ trợ"
            :model="formModel"
            attribute="dob"
            :errors="formErrors"
            placeholder="Năm sinh người cần hỗ trợ"
        ></form-input>

        <form-input
            label="Nghề nghiệp người cần hỗ trợ"
            :model="formModel"
            attribute="job"
            :errors="formErrors"
            placeholder="Nghề nghiệp người cần hỗ trợ"
        ></form-input>
      </div>
      <div class="col-md-8">
        <form-group-address
            :model="formModel"
            province-attribute="provinceCode"
            :province-disabled="false"
            district-attribute="districtCode"
            ward-attribute="wardCode"
            :errors="formErrors"
        ></form-group-address>

        <form-input
            label="Địa chỉ cần cứu trợ"
            :model="formModel"
            attribute="supportAddress"
            :errors="formErrors"
            placeholder="Địa chỉ cần cứu trợ"
        ></form-input>
        <div class="row">
          <div class="col-md-6">
            <form-input
                label="Số người đang gặp khó khăn"
                :model="formModel"
                attribute="peopleCount"
                :errors="formErrors"
                placeholder="Số người cần cứu trợ"
                type="number"
            ></form-input>
            <form-textarea
                label="Mô tả chi tiết nhu cầu hỗ trợ"
                :model="formModel"
                attribute="note"
                row="7"
                placeholder="Mô tả chi tiết nhu cầu hỗ trợ"
                :errors="formErrors"
            ></form-textarea>

            <form-select
                label="Có nằm trong vùng phong tỏa hay không"
                :model="formModel"
                attribute="blockadeArea"
                :errors="formErrors"
                :options="[
            {value: null, text: 'Không rõ'},
            {value: 1, text: 'Có'},
            {value: 2, text: 'Không'},
          ]"
            ></form-select>
          </div>
          <div class="col-md-6">
            <form-radio-group :stacked="true" :model="formModel" attribute="type" :errors="formErrors"
                              label="Nhu cầu cần hỗ trợ"
                              :options="typeOptions"></form-radio-group>
            <form-checkbox-group v-if="formModel.type === 3"
                                 stacked
                                 label="Nhu cầu nhu yếu phẩm"
                                 :model="formModel"
                                 attribute="htyp"
                                 :errors="formErrors"
                                 :options="[
                                            {value: 'Sữa', text: 'Sữa'},
                                            {value: 'Gạo', text: 'Gạo'},
                                            {value: 'Mỳ', text: 'Trứng'},
                                            {value: 'Rau', text: 'Rau'},
                                            {value: 'Mì tôm', text: 'Mì tôm'},
                                            {value: 'Thịt cá', text: 'Thịt cá'},
                                          ]">
            </form-checkbox-group>
            <b>
              <form-radio-group :model="formModel" attribute="emergency" :errors="formErrors"
                                label="Mức độ cần trợ giúp"
                                :options="[
                              {value: false, text: 'Không khẩn cấp'},
                              {value: true, text: 'Khẩn cấp'}]">
              </form-radio-group>
            </b>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" class="float-right" @click="showForm = false">Đóng</b-button>
      <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
        <b-spinner v-if="saveLoading" small></b-spinner>
        Lưu thông tin
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import CRUD from '@/mixins/CRUD';
import FormGroupAddress from '@/components/address/FormGroupAddress.vue';

export default {
  mixins: [CRUD],
  reloadBus: 'reloadIssueList',
  components: {FormGroupAddress},
  data: function () {
    return {
      service: '/issue',
      reloadBus: 'reloadIssueList',
      defaultFormModel: {
        name: null,
        provinceCode: 79,
        number: null,
        gender: 'unknown',
        dob: '',
        districtCode: null,
        wardCode: null,
        address: '',
        supportAddress: '',
        peopleCount: 0,
        supportContact: '',
        emergency: false,
        type: null,
        note: null,
        blockadeArea: 2,
        needer: true,
        needer_name: null,
        needer_number: null,
        htyp: [],
      },
      typeOptions: [
        {value: 1, text: 'Tư vấn sức khỏe phòng Covid'},
        {value: 2, text: 'Hỗ trợ y tế khẩn cấp (F0, F1)'},
        {value: 3, text: 'Hỗ trợ nhu yếu phẩm (HT-YP)'},
        {value: 4, text: 'Hỗ trợ tài chính (HT-09)'},
        {value: 5, text: 'Hỗ trợ lang thang (HT-LĐ)'},
        {value: 0, text: 'Khác'},
      ],
      genderOptions: [
        {value: 'male', text: 'Nam'},
        {value: 'female', text: 'Nữ'},
        {value: 'unknown', text: 'Không rõ'},
      ],
      callStatus: null,
    };
  },
  watch: {
    "formModel.number": {
      handler() {
        if (this.formModel.needer) {
          this.formModel.needer_name = this.formModel.name;
          this.formModel.needer_number = this.formModel.number;
        }
      }
    },
    "formModel.name": {
      handler() {
        if (this.formModel.needer) {
          this.formModel.needer_name = this.formModel.name;
          this.formModel.needer_number = this.formModel.number;
        }
      }
    },
    "formModel.needer": {
      handler() {
        if (this.formModel.needer) {
          this.formModel.needer_name = this.formModel.name;
          this.formModel.needer_number = this.formModel.number;
        }
      }
    }
  },
  methods: {
    answerCall() {
      this.$bus.$emit('answerCall');
    },
    endCall() {
      this.$bus.$emit('endCall');
    },
    callStatusUpdated(number, callId, callStatus) {
      this.callStatus = callStatus;
      if (callStatus === 'accepted') {
        if (number) this.formModel.number = number;
        if (callId) this.formModel.callId = callId;
      }
    },
    newIssueManually() {
      if (!this.showForm) {
        this.create();
      }
    }
  },
  mounted() {
    this.$bus.$on('callStatusUpdated', this.callStatusUpdated);
    this.$bus.$on('newIssueManually', this.newIssueManually);
  },
  beforeDestroy() {
    this.$bus.$off('callStatusUpdated');
    this.$bus.$off('newIssueManually');
  },
};
</script>
